import React  from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as fa from '@fortawesome/free-solid-svg-icons'
import * as generic from './generic.js';
import './App.css';
import './TitleCampeonato.css';

import Loader from './Loader.js';
import useLoadState from './useLoadState.js';
import TopPanel from './TopPanel.js';
import Campeonato from './Campeonato.js';
import CampeonatoSelect from './CampeonatoSelect.js';

import TopLeftLogo from './@brand/TopLeftLogo';
import TopRightLogo from './@brand/TopRightLogo';

import logoCamaliam from './assets/camaliam.svg';
import logoSrgoool from './assets/srgoool.svg';

function App() {

	const thisYear = new Date().getFullYear();
	const yearList = [
		//thisYear-2,
		thisYear-1,
		thisYear,
		thisYear+1
	];

	const hash = window.document.location.hash.substr(1).split('/');
	//const hash = "#2022/Copa-do-Mundo/Masculino/simulador-auto".substr(1).split("/");
	let hashYear = parseInt(hash.shift());
	let hashCampeonato = hash.shift();
	let hashSerie = hash.shift();
	let hashSub = hash.join('/');
	hashYear = "2022";
	hashCampeonato = "Copa-do-Mundo";
	hashSerie = "Masculino";
	hashSub = hashSub || "simulador-auto";

	const getHash = (year, campeonato, serie) => {
		return "#" + year + "/" + campeonato + "/" + serie + "/";
	};

	const setHash = (year, campeonato, serie) => {
		let hash = getHash(year, campeonato, serie);
		window.document.location.hash = hash + hashSub;
		return hash;;
	};

	const [ state, setState, render ] = useLoadState(

		{
			campeonatoList: [], campeonato: null, scrolled: false,
			year: yearList.indexOf(hashYear) >= 0 ? hashYear : thisYear
		},

		() => { return [ state.year ] },

		() => [ { url: "campeonato", params: { year: state.year } } ],

		(result) => {
			const campeonatoList = result[0].result;
			let item = campeonatoList.find(
				(item) => { 
					return item.link_campeonato === hashCampeonato && item.link_serie === hashSerie;
				}
			);
			if (!item) {
				item = campeonatoList.find((item) => item.favorite > 0);
			}
			if (!item && campeonatoList.length > 0) {
				item = campeonatoList[0];
			}
			//setHash(item?.year, item?.link_campeonato, item?.link_serie);
			setState({ ...state, campeonatoList: result[0].result, campeonato: parseInt(item?.id) });
		}
	);


	return render(() => {
		const campeonatoSelected = state.campeonatoList.find(item => (parseInt(item.id) === state.campeonato));
		//const baseUrl = getHash(campeonatoSelected?.year, campeonatoSelected?.link_campeonato, campeonatoSelected?.link_serie);
		const baseUrl = "#2022/Copa-do-Mundo/Masculino/";

		if (!campeonatoSelected) {
			return <Loader text="App"/>;
		}

		const togglePanel = function() {
			setState({ ...state, showPanel: !state.showPanel });
		};
		const updateScroll = function(e) {
			if (e.target.scrollTop > 50 && !state.scrolled) {
				setState({ ...state, scrolled: true, scrollTarget: e.target });
			} else
			if (e.target.scrollTop < 50 && state.scrolled) {
				setState({ ...state, scrolled: false, scrollTarget: null });
			}
		};
		const scrollToTop = function(e) {
			state.scrollTarget.scrollTop = 0;
		};

		return (
			<>
				{process.env.REACT_APP_HIDE_MENU ? null :
					(<TopPanel show={state.showPanel} onToggle={togglePanel}>
						<CampeonatoSelect
							onHeaderClick={togglePanel}
							yearList={yearList}
							year={state.year}
							campeonato={state.campeonato}
							campeonatoList={state.campeonatoList}
							onChangeYear={(year) => setState({ ...state, year: year })}
							onChange={(item) => setState({ ...state, campeonato: parseInt(item.id), showPanel: false })}
							/>
					</TopPanel>)
				}
				<div className="App" onScroll={updateScroll}>
					<div className="e0 fixed-top">
						{process.env.REACT_APP_HIDE_MENU ? null :
							(<div className="title-campeonato row" onClick={togglePanel}>
								<TopLeftLogo/>
								<span className="toggle-button">
									<FontAwesomeIcon icon={fa.faBars}/>
									<span className="title-menu-text">Menu</span>
								</span>
								<span className="fill">
								</span>
								<span className="e100 row title">
									<span className="ellipsis">{campeonatoSelected?.name_apelido}</span>
									{campeonatoSelected?.img_logo_serie ? <img alt="" className="logo-serie" src={generic.baseUrl + campeonatoSelected?.img_logo_serie}/> : 
										(campeonatoSelected?.img_logo_campeonato ? <img alt="" className="logo-campeonato" src={generic.baseUrl + campeonatoSelected?.img_logo_campeonato}/> : null)}
								</span>
								<TopRightLogo/>
							</div>)
						}
					</div>
					<Campeonato key={state.campeonato} campeonato={state.campeonato} baseUrl={baseUrl} subUrl={hashSub}/>
					<div className="e0 text-right logo-bar-placeholder">
					</div>
					<div className="e0 text-right logo-bar">
						<div><a target="_blank" href="https://www.srgoool.com.br">Conteúdo <img src={logoSrgoool}/></a></div>
						<div><a target="_blank" href="https://www.camaliam.com.br">Tecnologia <img src={logoCamaliam}/></a></div>
					</div>
				</div>
				<div onClick={scrollToTop} className="scroll-to-top button" data-show={state.scrolled}>
					<FontAwesomeIcon icon={fa.faChevronUp}/>
				</div>
			</>
		);
	});
}


export default App;
